const getAnnualSuffix = (count) => {
    if (count % 10 === 1 && count % 100 !== 11) {
        return 'st';
    } else if (count % 10 === 2 && count % 100 !== 12) {
        return 'nd';
    } else if (count % 10 === 3 && count % 100 !== 13) {
        return 'rd';
    } else {
        return 'th';
    }
};

const useGetAnnualDisplay = (useUpperCase) => {
    const startYear = 2018; 
    const currentYear = new Date().getFullYear();
    const annualCount = currentYear - startYear + 1;

    const display = `${annualCount}${getAnnualSuffix(annualCount)}`;
    return useUpperCase ? display.toUpperCase() : display;
};

export { useGetAnnualDisplay };